import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import PublicPageMetadata from './components/PublicPageMetadata';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import MembershipPage from './pages/MembershipPage';
import ProgramsPage from './pages/ProgramsPage';
import PersonalTrainingPage from './pages/PersonalTrainingPage';
import ReformerPilatesPage from './pages/ReformerPilatesPage';
import MX4Page from './pages/MX4Page';
import SwimmingPage from './pages/SwimmingPage';
import ContactPage from './pages/ContactPage';
import AmenitiesPage from './pages/AmenitiesPage';
import AboutPage from './pages/AboutPage';
import KidsFamilyPage from './pages/KidsFamilyPage';
import BirthdayPartyPage from './pages/BirthdayPartyPage';
import MassagePage from './pages/MassagePage';
import RentalsPage from './pages/RentalsPage';
import PartnershipsPage from './pages/PartnershipsPage';
import BookTourPage from './pages/BookTourPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import FacilityGuidelinesPage from './pages/FacilityGuidelinesPage';
import NotFoundPage from './pages/NotFoundPage';
import SchedulePage from './pages/SchedulePage';
import CardioPage from './pages/CardioPage';
import ScheduleCategoryPage from './pages/ScheduleCategoryPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import OurCoachesPage from './pages/OurCoachesPage';
import { Toaster } from './components/ui/sonner';
import { captureAttribution } from './lib/attribution';

// Read campaign tags off the landing URL before anything renders. Ad clicks and
// email links arrive as a full page load, so this runs while the query string is
// still present; the values are held for the session and attached at submit time.
captureAttribution();

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <PublicPageMetadata />
        <a className="dv-skip-link" href="#main-content">Skip to main content</a>
        <Navbar />
        <div id="main-content" tabIndex="-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/schedule/cardio" element={<CardioPage />} />
          <Route path="/schedule/mind-body" element={<ScheduleCategoryPage category="mind-body" />} />
          <Route path="/schedule/weight-training" element={<ScheduleCategoryPage category="weight-training" />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/programs/personal-training" element={<PersonalTrainingPage />} />
          <Route path="/personal-training" element={<PersonalTrainingPage />} />
          <Route path="/programs/kids-and-family" element={<KidsFamilyPage />} />
          <Route path="/kids-and-family" element={<KidsFamilyPage />} />
          <Route path="/kids" element={<KidsFamilyPage />} />
          <Route path="/childcare/birthday-party" element={<BirthdayPartyPage />} />
          <Route path="/programs/massage" element={<MassagePage />} />
          <Route path="/massage" element={<MassagePage />} />
          <Route path="/programs/reformer-pilates" element={<ReformerPilatesPage />} />
          <Route path="/reformer-pilates" element={<ReformerPilatesPage />} />
          <Route path="/pilates-brentwood" element={<ReformerPilatesPage />} />
          <Route path="/programs/mx4" element={<MX4Page />} />
          <Route path="/mx4" element={<MX4Page />} />
          <Route path="/programs/swim" element={<SwimmingPage />} />
          <Route path="/swim" element={<SwimmingPage />} />
          <Route path="/swimming" element={<SwimmingPage />} />
          <Route path="/swimming/levels-overview" element={<SwimmingPage />} />
          <Route path="/swimming/:slug" element={<SwimmingPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/category/:categorySlug" element={<BlogPage />} />
          <Route path="/category/blog/:categorySlug" element={<BlogPage />} />
          <Route path="/:y/:m/:d/:slug" element={<BlogPostPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/book-a-tour" element={<BookTourPage />} />
          <Route path="/amenities/book-a-tour" element={<BookTourPage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/partnerships" element={<PartnershipsPage />} />
          <Route path="/partners" element={<PartnershipsPage />} />
          <Route path="/about-us/partnerships" element={<PartnershipsPage />} />
          <Route path="/our-coaches" element={<OurCoachesPage />} />
          <Route path="/about-us/our-coaches-and-our-mx4-coaches" element={<OurCoachesPage />} />
          <Route path="/about-us/contact-us" element={<ContactPage />} />
          <Route path="/amenities" element={<AmenitiesPage />} />
          <Route path="/amenities/rockwall" element={<AmenitiesPage />} />
          <Route path="/amenities/kids-club" element={<KidsFamilyPage />} />
          <Route path="/amenities/dry-sauna" element={<AmenitiesPage />} />
          <Route path="/amenities/hydro-massage" element={<MassagePage />} />
          <Route path="/amenities/group-fitness" element={<AmenitiesPage />} />
          <Route path="/amenities/cycle" element={<AmenitiesPage />} />
          <Route path="/amenities/pickleball" element={<AmenitiesPage />} />
          <Route path="/amenities/locker-rooms" element={<AmenitiesPage />} />
          <Route path="/amenities/sauna-steam" element={<AmenitiesPage />} />
          <Route path="/amenities/pool" element={<AmenitiesPage />} />
          <Route path="/amenities/strength-training" element={<AmenitiesPage />} />
          <Route path="/amenities/rentals" element={<RentalsPage />} />
          <Route path="/rentals" element={<RentalsPage />} />
          <Route path="/rental" element={<RentalsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/terms-conditions" element={<TermsPage />} />
          <Route path="/facility-guidelines" element={<FacilityGuidelinesPage />} />
          <Route path="/facility-guidelines-and-policies" element={<FacilityGuidelinesPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
